import React from 'react';
import './Spinner.css';

/**
 * Displays a spinner
 */
export default function Spinner() {
  return (
    <div className="spinner la-ball-beat la-dark">
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}
